import imageCompression from 'browser-image-compression';

export async function compressImage(imageFile) {
  try {
    // Convert base64 to blob
    const base64Response = await fetch(imageFile);
    const blob = await base64Response.blob();

    const options = {
      maxSizeMB: 0.5,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
      fileType: 'image/jpeg'
    };

    const compressedBlob = await imageCompression(blob, options);
    return compressedBlob;
  } catch (error) {
    console.error('Error compressing image:', error);
    throw new Error('Failed to compress image. Please try again.');
  }
}
